import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classnames from 'classnames';

const SlideOutContext = createContext({});

const SlideOutProvider = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);

  const toggle = () =>
    setIsVisible(!isVisible);

  return (
    <SlideOutContext.Provider
      value={{
        isVisible,
        toggle,
      }}
    >
      {children}
    </SlideOutContext.Provider>
  );
};

SlideOutProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const useSlideOut = () =>
  useContext(SlideOutContext);

const Container = styled.div`
  transition: all ${({ speed }) => speed}ms ease-in-out;

  .slide-out-container__inner {
    transition: all ${({ speed }) => speed * 1.5}ms ease-in-out;
  }
`;

const SlideOut = ({ children, ...props }) => {
  const { isVisible } = useSlideOut();

  const c = classnames(
    'slide-out-container',
    {
      'is-visible': isVisible,
    },
  );

  return (
    <Container {...props} className={c}>
      <div className="m-3 slide-out-container__inner">
        {children}
      </div>
    </Container>
  );
};

SlideOut.propTypes = {
  children: PropTypes.node.isRequired,
  speed: PropTypes.number,
  isVisible: PropTypes.bool,
};

SlideOut.defaultProps = {
  speed: 500,
  isVisible: false,
};

export default SlideOut;
export {
  SlideOutProvider,
  useSlideOut,
};
